import { creditCardType } from 'card-validator';
import { excludePatternsFromCardType } from '../../utilities/card';
import { CardTypeConfig } from '../../interfaces/card-type-config';

const excludedPatterns = [493698];

export const MAESTRO_CARD_TYPE_CONFIG: CardTypeConfig = excludePatternsFromCardType(
    creditCardType.types.MAESTRO, excludedPatterns
);
